import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const fetchCampaignsActivity = async (hubId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGNS_ACTIVITY.url.replace('<hubId>', hubId), {params: {...payload}});
    return response.data;
}